import { render } from "./shift-header.vue?vue&type=template&id=f272dc54&scoped=true"
import script from "./shift-header.vue?vue&type=script&lang=js"
export * from "./shift-header.vue?vue&type=script&lang=js"

import "./shift-header.vue?vue&type=style&index=0&id=f272dc54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f272dc54"]])

export default __exports__